<template>
  <transition name="slideUp">
    <div id="proximity" v-if="active">
      <div class="proximity__header">
        <div class="proximity__header-content">
          <div class="header__title">
            <svg class="icon icon-map" aria-hidden="true" role="img">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-map"></use>
            </svg>
            A proximité
          </div>
          
          <span class="distance">{{ radius }} kilomètre(s)</span>
        </div>
        <ul class="group-buttons">
          <li>
            <button @click="expandProximity">
              <svg v-if="expand" class="icon icon-reduce" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-reduce"></use>
              </svg>
              <svg v-else class="icon icon-expand" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-expand"></use>
              </svg>
            </button>
          </li>
          <li>
            <button @click="closeProximity">
              <svg class="icon icon-close" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
              </svg>
            </button>
          </li>
        </ul>
      </div>
      <div class="proximity__content" v-if="expand">
        <input type="range" :min="rangeMin" :max="rangeMax" step="0.1" v-model="radius" @change="isInRange">
        <form action="#">
          <p>N'afficher que ces catégories (optionnel):</p>
          <div class="form__row" v-for="cat in categories">
            <input type="checkbox" :id="`${cat.id}-${cat.slug}`" :value="cat.id" v-model="selectedCat" @change="getCats()" :checked="true">
            <label :for="`${cat.id}-${cat.slug}`">{{ cat.name }}</label>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
  /* global L */
  /* global cgy_vars */
  /* eslint no-undef: "error" */
  import store from '../store/store'
  import json from '../store/jsonUrl'
  import _ from 'lodash'

  export default {
    name: 'proximity',
    data () {
      return {
        active: false,
        expand: false,
        radius: (cgy_vars.around.min / 1000),
        rangeMin: (cgy_vars.around.min / 1000),
        rangeMax: (cgy_vars.around.max / 1000),
        iconUrl: cgy_vars.defaultMarker,
        proxMarker: '',
        categories: [],
        circle: '',
        strokeColor: cgy_vars.circle.strokeColor,
        fillColor: cgy_vars.circle.fillColor,
        selectedCat: [],
        places: [],
        markers: [],
        info: ''
      }
    },
    watch: {
      radius: function (newRadius) {
        this.circle.setRadius((newRadius * 1000) / 2)
      }
    },
    mounted () {
      // get categories
      if (store.cache.categories !== '') {
        this.$http.get(json.url.categories).then((response) => {
          this.categories = response.data
          store.cache.categories = this.categories
        })
      } else {
        this.categories = store.cache.categories
      }

      // get all places
      this.$http.get(json.url.places).then((response) => {
        this.places = response.data
      })

      // get place info index
      for (var i = 0; i < this.$parent.$children.length; i++) {
        if (this.$parent.$children[i].$options.name === 'place-info') {
          this.info = i
        }
      }
    },
    methods: {
      proximityOnClick: function (currentPlace) {
        this.active = true
        this.expand = true
        this.radius = (cgy_vars.around.min / 1000)
        this.deleteAllMarkers()
        this.addProximityMarker(currentPlace)
        this.drawProximityCircle(currentPlace)
      },
      deleteAllMarkers: function (id) {
        this.markers = []
        store.cache.markersGroup.clearLayers()
      },
      addProximityMarker: function (place) {
        if (this.proxMarker && this.proxMarker !== '') {
          store.state.map.removeLayer(this.proxMarker)
        }
        let markerIcon = L.icon({
          iconUrl: this.iconUrl,
          iconSize: [21, 26],
          iconAnchor: [10.5, 26]
        })
        this.proxMarker = L.marker([place.lat, place.lng], {icon: markerIcon, draggable: true})
        this.proxMarker.setZIndexOffset(1000)
        store.state.map.addLayer(this.proxMarker)
        this.addDraggableListener()
      },
      addDraggableListener: function () {
        let that = this
        this.proxMarker.on('drag', function (e) {
          let marker = e.target
          let latlng = marker.getLatLng()
          that.updateProximityCircle(latlng)
        })
      },
      drawProximityCircle: function (place) {
        if (this.circle && this.circle !== '') {
          store.state.map.removeLayer(this.circle)
        }
        let lat = place.lat
        let lng = place.lng
        this.circle = L.circle([lat, lng], {
          color: this.strokeColor,
          fillColor: this.fillColor,
          fillOpacity: 0.5,
          radius: (this.radius * 1000) / 2
        }).addTo(store.state.map)
        this.isInRange()
      },
      updateProximityCircle: function (latlng) {
        this.circle.setLatLng(latlng)
        this.isInRange()
      },
      getCats: function () {
        let id = this.getSelectedCatsKey()
        let req = ''
        this.getSelectedCats().forEach(function (cat) {
          req += `&terms[]=${cat}`
        })
        if (store.cache.places[id] && store.cache.activate) {
          this.places = store.cache.places[id]
          this.deleteAllMarkers()
          this.isInRange()
        } else {
          this.$http.get(`${json.url.places}&${req}`).then((response) => {
            this.places = response.data
            store.cache.places[id] = response.data
            this.deleteAllMarkers()
            this.isInRange()
          }, (response) => {
            console.log('error', response)
          })
        }
      },
      getSelectedCats: function () {
        return this.selectedCat.sort()
      },
      getSelectedCatsKey: function () {
        return this.getSelectedCats().join('-')
      },
      isInRange: function () {
        let that = this
        this.places.forEach(function (place) {
          if (place.lat && place.lng) {
            let marker = L.marker([place.lat, place.lng]).on('click', that.$parent.$children[that.info].markerOnClick)
            if (marker.getLatLng().distanceTo(that.circle.getLatLng()) <= that.circle.getRadius()) {
              if (!_.find(that.markers, {id: place.id})) {
                that.setupMarker(marker, place)
                that.markers.push({id: place.id, marker: marker})
              }
            } else {
              if (_.find(that.markers, {id: place.id})) {
                let toDel = _.find(that.markers, {id: place.id})
                let arrIndex = that.markers.indexOf(toDel)
                store.state.map.removeLayer(toDel.marker)
                store.cache.markersGroup.removeLayer(toDel.marker)
                that.markers.splice(arrIndex, 1)
              }
            }
          }
        })
        store.state.map.addLayer(store.cache.markersGroup)
      },
      setupMarker: function (marker, place) {
        let markerIcon = store.iconOptions({
          options: {
            iconUrl: place.icon
          }
        })
        marker.setIcon(markerIcon)
        marker.placeId = place.id
        store.cache.markersGroup.addLayer(marker)
      },
      closeProximity: function (id) {
        // close proximity panel
        this.active = false
        this.expand = false
        this.deleteAllMarkers(id)
        // remove proximity marker and circle
        store.state.map.removeLayer(this.proxMarker)
        store.state.map.removeLayer(this.circle)
      },
      expandProximity: function () {
        this.expand = !this.expand
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Proximity.vue?1c2d252a